import { useState, useEffect, useRef } from 'react'

/**
 * CountStat — animates a number from 0 to `target` when it
 * scrolls into view. Used for the hero stats strip.
 */
export function CountStat({ target, suffix, label }) {
  const [val, setVal] = useState(0)
  const ref = useRef()
  useEffect(() => {
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        let cur = 0
        const step = Math.ceil(target / 40)
        const t = setInterval(() => {
          cur = Math.min(cur + step, target)
          setVal(cur)
          if (cur >= target) clearInterval(t)
        }, 35)
        io.disconnect()
      }
    }, { threshold: 0.5 })
    if (ref.current) io.observe(ref.current)
    return () => io.disconnect()
  }, [target])
  return (
    <div ref={ref} className="stat">
      <div className="sv">{val}{suffix}</div>
      <div className="sl">{label}</div>
    </div>
  )
}
